interface ErrorData {
  message: string
}

export class ErrorResponse {
  private code: number
  private data: ErrorData

  constructor(code: number, data: ErrorData) {
    this.code = code
    this.data = data
  }

  /**
   * HTTP status of the failed call. Exposed so callers can tell one failure from another — the auth
   * session in particular has to separate a dead session (401) from a transient upstream fault (502/503),
   * which it must not sign the customer out for.
   */
  get status(): number {
    return this.code
  }

  get message(): string {
    return this.data?.message ?? ''
  }
}
